import hamburgericon from "../../assets/images/icon-hamburger.svg";
import closeicon from "../../assets/images/icon-close.svg";
import { useState } from "react";
import MobileNav from "./MobileNav";
import Nav from "./Nav";

export default function Header() {
  const [openham, setOpenHam] = useState(false);
  const [product, setProduct] = useState(false);
  const [company, setCompany] = useState(false);
  const [connect, setConnect] = useState(false);

  const handleToggleHamburger = () => {
    setOpenHam(!openham);
  };

  const handleToggleMenu = (item) => {
    if (item === "product") {
      setProduct(!product);
    }

    if (item === "company") {
      setCompany(!company);
    }

    if (item === "connect") {
      setConnect(!connect);
    }
  };

  return (
    <header className="px-3 py-4 bg-bright-red bg-mobile h-4/6 bg-contain bg-no-repeat bg-center rounded-bl-big tablet:rounded-none">
      <article className="flex justify-between flex-auto pt-5 pb-9 md:hidden">
        <h1 className="font-bold text-2xl text-white">Blogr</h1>
        {/* Mobile Nav */}
        <img
          onClick={handleToggleHamburger}
          src={openham ? closeicon : hamburgericon}
          className="w-6 h-6 tablet:hidden"
          alt=""
        />
        {openham ? (
          <nav className="absolute top-36 left-0 bg-white flex mx-5 px-16 py-16	 drop-shadow-md rounded text-center md-phone:px-24 md-phone:py-24 lg-phone:py-28 lg-phone:px-28">
            <MobileNav
              handleToggleMenu={handleToggleMenu}
              product={product}
              company={company}
              connect={connect}
            />
          </nav>
        ) : (
          ""
        )}
      </article>

      {/* Tablet And Desktop Nav */}
      <Nav handleToggleMenu={handleToggleMenu} />

      <article className="flex flex-wrap justify-center text-center py-20 px-1 tablet:flex-col tablet:items-center tablet:pt-28">
        <h2 className="text-white text-3xl font-semibold tablet:text-4xl">
          A modern<br className="tablet:hidden"></br> publishing platform
        </h2>
        <p className="text-white text-lg py-3 ">
          {" "}
          Grow your audience and build your online brand
        </p>
        <div className="flex justify-evenly py-8 w-96">
          <button className="bg-white text-bright-red py-3 px-4 rounded-full font-semibold">
            Start for Free
          </button>
          <button className="border-solid border-2 border-white py-2 px-5 rounded-full text-white font-semibold ">
            Learn More
          </button>
        </div>
      </article>
    </header>
  );
}
